// PackageCard.tsx
import React from 'react';
import { FaStar } from 'react-icons/fa';

interface PackageCardProps {
  pkg: {
    name: string;
    label: string;
    description?: string;
    bgImage?: string;
    image?: string;
    onImageButtons?: Array<{ label: string; value: string; style: string }>;
    rating?: number;
  };
  index: number;
  onShowItem: (item: any) => void;
}

const PackageCard = ({ pkg, index, onShowItem }: PackageCardProps) => {
  // Get best price from onImageButtons
  const getBestPrice = () => {
    if (!pkg.onImageButtons || pkg.onImageButtons.length === 0) return null;
    const prices = pkg.onImageButtons.map(b => parseInt(b.value.replace(/[^0-9]/g, '')));
    const minPrice = Math.min(...prices);
    const priceItem = pkg.onImageButtons.find(b => 
      parseInt(b.value.replace(/[^0-9]/g, '')) === minPrice
    );
    return priceItem;
  };

  const bestPrice = getBestPrice();

  return (
    <div 
      className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
      onClick={() => onShowItem(pkg)}
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={pkg.bgImage || pkg.image}
          alt={pkg.name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        {pkg.rating && (
          <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full flex items-center gap-1">
            <FaStar className="text-yellow-400 text-xs" />
            <span className="font-secondary text-xs font-semibold text-gray-700">{pkg.rating}</span>
          </div>
        )}
        {bestPrice && (
          <div className="absolute bottom-3 left-3 bg-black/60 backdrop-blur-sm px-3 py-1.5 rounded-full">
            <span className="text-white text-sm font-semibold">From {bestPrice.value}</span>
          </div>
        )}
      </div>
      
      <div className="p-5">
        <h3 className="font-primary font-bold text-lg text-gray-800 mb-2">
          {pkg.label || pkg.name}
        </h3>
        <p className="font-secondary text-sm text-gray-500 leading-relaxed line-clamp-2">
          {pkg.description}
        </p>
        <button 
          className="mt-4 w-full px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all duration-300 hover:scale-[1.02]"
          onClick={(e) => {
            e.stopPropagation();
            onShowItem(pkg);
          }}
        >
          View Details
        </button>
      </div>
    </div>
  );
};

export default PackageCard;